import { PageMetaData, useTracking } from '@packages/tracking';

import type { FC } from 'react';
import { useEffect } from 'react';

export type TrackingProps = {
  pageType: 'serp' | 'productlist' | 'sis';
  /** the search query */
  query?: string;
  searchId?: string;
  majorMkz?: number;
  categoryPath?: {
    id: string;
    name: string;
  }[];
  landmarkUrls?: string[];
};

/**
 * Search Tracking component for pushing the following events to the GTM datalayer
 * - 'search-page-landmark'
 * - 'pageMetaData'
 * */
export const Tracking: FC<TrackingProps> = ({
  pageType,
  query,
  searchId,
  majorMkz,
  categoryPath,
  landmarkUrls,
}) => {
  const dispatchGTMEvent = useTracking();

  useEffect(() => {
    if (landmarkUrls && landmarkUrls?.length > 0) {
      try {
        landmarkUrls.forEach((url) =>
          dispatchGTMEvent({ event: 'search-page-landmark', eventValue: url }),
        );
      } catch (err) {
        // ignore
      }
    }
  }, [dispatchGTMEvent, landmarkUrls]);

  return (
    <PageMetaData
      page={{ type: pageType }}
      query={query}
      searchId={searchId}
      marketcode={majorMkz}
      categoryPath={categoryPath}
    />
  );
};
